import { createCustomIcon } from './utils/createCustomIcon';

const UserRoundReceivedIcon = createCustomIcon({
  displayName: 'UserRoundReceivedIcon',
  children: (
    <path
      d="M2 21C1.99992 19.4603 2.44413 17.9533 3.27935 16.6599C4.11456 15.3664 5.30527 14.3415 6.7086 13.708C8.11193 13.0746 9.66824 12.8595 11.1908 13.0887C12.7133 13.3178 14.1373 13.9815 15.292 15M22 19C22 19 16.8431 19 14.5 19M17.5 22L14.5 19L17.5 16M15 8C15 10.7614 12.7614 13 10 13C7.23858 13 5 10.7614 5 8C5 5.23858 7.23858 3 10 3C12.7614 3 15 5.23858 15 8Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
});

export default UserRoundReceivedIcon;
